const rem = (px, base) => {
    if (!base) {
        base = 16;
    }
    return px / base + 'rem';
};

export { rem };
//# sourceMappingURL=rem.js.map
